// buildRangeConfig.js
// Matches logic from AdvancedOrderPopup.handleFinalDone() RANGE branch. :contentReference[oaicite:4]{index=4}

function deriveQuantityFromAmount(amountNum, avgPrice) {
    if (!avgPrice || avgPrice <= 0 || Number.isNaN(avgPrice)) return NaN;
    return Math.floor(amountNum / avgPrice);
}

function buildNonPreopenBase({
                                 side,
                                 executionMode,
                                 singleLargestOrderValue,
                                 totalDurationValue,
                                 totalDurationUnit,
                                 selectedUserId,
                             }) {
    const execMode = (executionMode === "RELAXED" || executionMode === "AGGRESSIVE")
        ? executionMode
        : "AGGRESSIVE";

    if (execMode === "RELAXED" && (totalDurationValue === "" || Number(totalDurationValue) <= 0)) {
        return { error: "Total execution duration must be > 0 for RELAXED execution mode." };
    }

    const slvParsed = parseFloat(singleLargestOrderValue);
    if (!slvParsed || Number.isNaN(slvParsed) || slvParsed <= 0) {
        return { error: "Single largest order value (₹) must be > 0." };
    }

    let th = null;
    if (totalDurationValue !== "") {
        const raw = parseFloat(totalDurationValue);
        if (Number.isNaN(raw) || raw <= 0) {
            return {
                error:
                    execMode === "RELAXED"
                        ? "Total execution duration must be > 0 for RELAXED execution mode."
                        : "Total execution duration must be > 0 if specified.",
            };
        }

        switch (totalDurationUnit) {
            case "MINUTES":
                th = raw / 60.0;
                break;
            case "DAYS":
                th = raw * 24.0;
                break;
            case "HOURS":
            default:
                th = raw;
                break;
        }
    }

    return {
        base: {
            side,
            executionMode: execMode,
            totalDurationHours: th,
            singleLargestOrderValue: slvParsed,
            zerodhaUserId: selectedUserId || null,
        },
    };
}

export function buildRangeConfig({
                                     side,

                                     minPrice,
                                     maxPrice,
                                     delayMinutes,
                                     quantity,
                                     amount,
                                     lotSize,
                                     executionMode,
                                     singleLargestOrderValue,
                                     totalDurationValue,
                                     totalDurationUnit,

                                     selectedUserId,
                                 }) {
    const baseRes = buildNonPreopenBase({
        side,
        executionMode,
        singleLargestOrderValue,
        totalDurationValue,
        totalDurationUnit,
        selectedUserId,
    });
    if (baseRes.error) return { error: baseRes.error };

    const minP = parseFloat(minPrice);
    const maxP = parseFloat(maxPrice);
    const d = parseFloat(delayMinutes || "0");

    if (!minP || minP <= 0 || Number.isNaN(minP)) return { error: "Lowest price must be > 0." };
    if (!maxP || maxP <= 0 || Number.isNaN(maxP)) return { error: "Highest price must be > 0." };
    if (maxP < minP) return { error: "Highest price must be ≥ lowest price." };
    if (!Number.isFinite(d) || d <= 0) {
             return { error: "Delay (minutes) must be > 0 for RANGE orders." };
    }
    const avgPrice = (minP + maxP) / 2.0;

    const lot = Number(lotSize);
    if (!Number.isFinite(lot) || lot <= 0) {
        return { error: "Lot size is not available for this symbol. Cannot place RANGE order." };
    }

    const qtyNum = parseFloat(quantity);
    const amountNum = parseFloat(amount);

    const hasQty = !Number.isNaN(qtyNum) && qtyNum > 0;
    const hasAmount = !Number.isNaN(amountNum) && amountNum > 0;

    if (hasQty && hasAmount) return { error: "Enter either quantity OR amount, not both." };
    if (!hasQty && !hasAmount) return { error: "Please enter quantity or amount." };

    let finalQty;

    if (hasQty) {
        const q = Math.floor(qtyNum); // quantity should be integer
        if (!Number.isFinite(q) || q <= 0) return { error: "Expected quantity must be > 0." };

        if (q < lot) return { error: `Expected quantity must be at least 1 lot (${lot}).` };
        if (q % lot !== 0) return { error: `Expected quantity must be a multiple of lot size (${lot}).` };

        finalQty = q;

    } else {
        // amount rule: at LOWER range price
        const minAmt = lot * minP;
        if (amountNum + 1e-9 < minAmt) {
            return { error: `Amount is too small. Minimum is 1 lot worth at lowest price: ₹${minAmt.toFixed(2)}.` };
        }

        // derive qty using min price (strictest), then lot-floor
        const derivedQty = Math.floor(amountNum / minP);
        const lotAdjusted = Math.floor(derivedQty / lot) * lot;

        if (!Number.isFinite(lotAdjusted) || lotAdjusted < lot) {
            return { error: `Amount is too small. It should buy at least 1 lot (${lot}) at the lowest price.` };
        }

        finalQty = lotAdjusted;
    }

    return {
        config: {
            ...baseRes.base,
            mode: "RANGE",
            minPrice: minP,
            maxPrice: maxP,
            delayMinutes: d,
            expectedQuantity: finalQty,
            lotSize: lot,
        },
        shouldAutoClose: true,
    };
}
